import { API } from 'aws-amplify'

import { CreateQuizDto, QuizDto, SendInvitationProps } from 'types'

export const getQuiz = async (subCategoryId: string, quizId: string): Promise<QuizDto> => {
    return API.get('api', `/subcategory/${subCategoryId}/quizzes/${quizId}`, {})
}

export const getMyQuizzes = async (): Promise<QuizDto[]> => {
    return API.get('api', '/quizzes', {})
}

export const getTotalNumberOfQuizzes = async (): Promise<number> => {
    return API.get('open-api', '/quizzes/total-number', {})
}


export const getMyQuizzesBySubCategory = async (subCategoryId: string): Promise<QuizDto[]> => {
    return API.get('api', `/quizzes/${subCategoryId}`, {})
}

export const getQuizzesBySubCategory = async (subCategoryId: string) => {
    return API.get('api', `/subcategory/${subCategoryId}/quizzes`, {})

}

export const getQuizzesByCategory = async (categoryId: string): Promise<any[]> => {
    return API.get('api', `/category/${categoryId}/quizzes`, {})

}

export const getAllQuizzes = async (subCategoryId: string): Promise<QuizDto[]> => {
    return API.get('api', `/all/quizzes/${subCategoryId}`, {})
}

export const createQuiz = async (subCategoryId: string, { title, description, descriptionImage, descriptionAudio, answerImage, answerAudio, answer, category }: CreateQuizDto): Promise<string> => {
    return API.post('api', `/subcategory/${subCategoryId}/quizzes`, { body: { title, description, descriptionImage, descriptionAudio, answerImage, answerAudio, answer, category } })
}


export const updateQuiz = async (subCategoryId: string, quizId: string,
    { title, description, descriptionImage, descriptionAudio, answerImage, answerAudio, answer, category }: CreateQuizDto): Promise<QuizDto> => {
    return API.put('api', `/subcategory/${subCategoryId}/quizzes/${quizId}`,
        { body: { title, description, descriptionImage, descriptionAudio, answerImage, answerAudio, answer, category } })
}

export const deleteQuiz = async (subCategoryId: string, quizId: string): Promise<string> => {
    return API.del('api', `/subcategory/${subCategoryId}/quizzes/${quizId}`, {})
}


export const notifyError = async (quizInfo: SendInvitationProps): Promise<void> => {
    return API.post('api', `/notify-error`, { body: {...quizInfo } })
}

export const paginateAndFilter = async (
    limit:number, pk_start_key: string, sk_start_key: string, user_id: string, category: string, subcategory: string, from_admin: boolean, grade: string, subject: string, is_shared: boolean
    ): Promise<QuizDto[]> => {
    let queryParams = Object.entries({limit, pk_start_key, sk_start_key, user_id, category, subcategory, from_admin, grade, subject, is_shared}).filter(([_, v]) => v).map(([k, v]) => `${k}=${v}`)
    const queryParam = queryParams.join('&')
    return API.get('api', `/quizzes/paginate-and-filter?${queryParam}`, {})
}